import React from 'react';

function ContactUsSchema() {
  const logoUrl =
    'https://cdn-assets.prod.thinkofliving.com/_next/static/images/tol-logo-text-7f98a1ca4e741f5e61ef43ea8e9d5144.jpg';
  const schema = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    'name': 'Thinkofliving',
    'url': 'https://thinkofliving.com/contact-us/',
    'logo': logoUrl,
    'description':
      'ติดต่อทีมงาน ThinkOfLiving.COM และรายการ “คิดเรื่องอยู่” พร้อมสอบถามข้อมูลเพิ่มเติม หรือติดต่อลงโฆษณาติดต่อเราได้ทุกวันทำการ',
    'contactPoint': [
      {
        '@type': 'ContactPoint',
        'telephone': '+662-204-9598, ',
        'email': 'ae@thinkofliving.com',
        'contactType': 'sales',
        'url': 'https://thinkofliving.com/contact-us/',
      },
    ],
    'address': {
      '@type': 'PostalAddress',
      'addressLocality': 'รัชดาภิเษก',
      'addressRegion': 'กรุงเทพมหานคร',
      'postalCode': '10310',
      'streetAddress': 'อาคารซีดับเบิ้ลยู ทาวเวอร์',
    },
  };

  return (
    <script
      type="application/ld+json"
      dangerouslySetInnerHTML={{ __html: JSON.stringify(schema) }}
    />
  );
}

export default ContactUsSchema;
